import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Sports.css';

const Sports = () => {
  return (
    <>
      <Helmet>
        <title>Sports - Breaking News & Analysis | Redbox Global</title>
        <meta name="description" content="Latest sports news, analysis, and exclusive interviews covering Champions League football, tennis Grand Slams, NBA basketball, Olympics, and major sporting events worldwide." />
        <meta name="keywords" content="sports news, Champions League, tennis Grand Slam, NBA basketball, Olympics, football, sports analysis, athlete interviews, sporting events" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/sports" />
        <meta property="og:title" content="Sports - Breaking News & Analysis | Redbox Global" />
        <meta property="og:description" content="Latest sports news covering Champions League, tennis, NBA basketball, Olympics, and exclusive athlete interviews." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/sports" />
        <meta name="twitter:title" content="Sports - Breaking News & Analysis | Redbox Global" />
        <meta name="twitter:description" content="Latest sports news covering Champions League, tennis, NBA basketball, Olympics, and exclusive athlete interviews." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/sports" />
      </Helmet>
      
      <div className="page-container">
      <div className="page-header">
        <h1>Sports</h1>
        <p className="page-subtitle">Breaking sports news, analysis, and exclusive athlete interviews</p>
      </div>
      
      <div className="page-content">
        <a href="/article/champions-league-final-preview" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <div className="featured-article">
            <div className="featured-image">
              <img src="https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=1200&h=600&fit=crop" alt="Football championship" />
            </div>
            <div className="featured-content">
             
              <h2>The Road to Glory: Champions League Final Preview</h2>
              <p>An in-depth analysis of the two powerhouse teams battling for European football's most prestigious trophy, featuring exclusive interviews with key players and coaches.</p>
              <span className="article-meta">This Week's Feature</span>
            </div>
          </div>
        </a>

        <div className="content-grid">
          <a href="/article/tennis-grand-slam-sensation" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1622279457486-62dcc4a431d6?w=600&h=400&fit=crop" alt="Tennis" />
              </div>
              <div className="article-content">
                
                <h2>Rising Star Dominates Grand Slam Tournament</h2>
                <p>The 20-year-old phenom is rewriting tennis history with an unprecedented run.</p>
                <span className="article-meta">February 3, 2026</span>
              </div>
            </article>
          </a>

          <a href="/article/nba-trade-deadline-analysis" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1546519638-68e109498ffc?w=600&h=400&fit=crop" alt="Basketball" />
              </div>
              <div className="article-content">
               
                <h2>NBA Trade Deadline: Winners and Losers</h2>
                <p>Analyzing the blockbuster deals that could reshape the championship race.</p>
                <span className="article-meta">February 2, 2026</span>
              </div>
            </article>
          </a>

          <a href="/article/olympic-athletes-preparation" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=600&h=400&fit=crop" alt="Olympics" />
              </div>
              <div className="article-content">
                
                <h2>Inside Olympic Athletes' Training Regimens</h2>
                <p>How elite competitors are preparing for the upcoming Games with cutting-edge methods.</p>
                <span className="article-meta">February 1, 2026</span>
              </div>
            </article>
          </a>
        </div>
      </div>
    </div>
    </>
  );
};

export default Sports;
